/* sgpf-accordion.js — FAQ accordion, hardened.

   The previous version only toggled maxHeight and opacity. A panel authored as
   `style="display:none"` could therefore never be reopened: the click fired, the
   height was set, and nothing moved. That is exactly how the NVISAGE N2 launched
   with eight dead FAQ rows.

   This version NORMALISES every panel on init, so a template written either way
   works without being edited:
     - display:none            -> converted to the max-height pattern
     - max-height/overflow/opacity missing -> added
   It also delegates the click from the document, so panels injected after load
   (or by an app) still work, and it re-normalises when new ones appear. */
(function () {
  'use strict';

  var OPEN = '1';

  function normalise(panel) {
    if (!panel || panel.dataset.sgpfReady === '1') return;
    var cs = window.getComputedStyle(panel);
    // a panel hidden with display:none can never animate - convert it
    if (cs.display === 'none') panel.style.display = 'block';
    if (!panel.style.overflow) panel.style.overflow = 'hidden';
    if (!panel.style.maxHeight) panel.style.maxHeight = '0';
    if (!panel.style.opacity) panel.style.opacity = '0';
    // FAQ motion intentionally disabled: instant open/close avoids iOS/WebView shake.
    panel.style.transition = 'none';
    panel.dataset.sgpfReady = '1';
  }

  function panelFor(btn) {
    var p = btn.nextElementSibling;
    // tolerate a wrapper or a text node between button and panel
    while (p && p.nodeType === 1 && !/sgp-fa/.test(p.className || '') &&
           p.nextElementSibling && !p.querySelector('.sgp-fa')) {
      if (/sgp-fq/.test(p.className || '')) return null;
      p = p.nextElementSibling;
    }
    if (p && p.querySelector && !/sgp-fa/.test(p.className || '')) {
      var inner = p.querySelector('.sgp-fa');
      if (inner) return inner;
    }
    return p;
  }

  function setOpen(btn, panel, open) {
    var icon = btn.querySelector('.sgp-fi');
    if (open) {
      panel.style.maxHeight = 'none';
      panel.style.opacity = '1';
      btn.setAttribute('data-open', OPEN);
      btn.setAttribute('aria-expanded', 'true');
      if (icon) icon.textContent = '−';
    } else {
      panel.style.maxHeight = '0';
      panel.style.opacity = '0';
      btn.setAttribute('data-open', '0');
      btn.setAttribute('aria-expanded', 'false');
      if (icon) icon.textContent = '+';
    }
  }

  function init(root) {
    var btns = (root || document).querySelectorAll('.sgp-fq');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      normalise(panelFor(btn));
      if (!btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', btn.getAttribute('data-open') === OPEN ? 'true' : 'false');
      }
    }
  }

  // delegated, so panels added later still respond
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sgp-fq');
    if (!btn) return;
    var panel = panelFor(btn);
    if (!panel) return;
    normalise(panel);
    setOpen(btn, panel, btn.getAttribute('data-open') !== OPEN);
  });

  function boot() {
    init(document);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { init(document); break; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
